import React from 'react';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import {Box} from "@mui/material";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);


export function BarChart({da}) {
  const labels = Object.keys(da).map((label) => label);
  const dataL = Object.keys(da).map((labels) => da[labels])
  const data = {
    labels ,
    legend: false,
    datasets: [
      {
        label: '',
        data: dataL,
        backgroundColor: '#204488',
      },

    ],

  };
  const options = {
    responsive: true,
    scales: {
      x: {
        grid: {
          display: true,
          drawBorder: true,
          drawOnChartArea: false,
          drawTicks: false,
        },
        ticks: {
          callback: function(value, index, ticks, le) {
            return labels[value].toUpperCase() + 'S';
          },
          font: {
            size: 16
          },
          padding: 20
        }

      },
      y: {
        grid: {
          display: true,
          drawBorder: true,
          drawOnChartArea: false,
          drawTicks: false,
        },
        ticks: {

          font: {
            size: 18
          },
          padding: 20,

        }

      },
    },
    plugins: {
      legend: false
    }


  };
  return <Box maxWidth={'lg'}>
    <Bar options={options} data={data} />
  </Box>;
}
